// // src/App.js

// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
// import MenuBook from "./components/MenuBook";
// import UploadMenuPage from "./components/UploadMenuPage";
// import ManageMenuPages from "./components/ManageMenuPages";

// function App() {
//   return (
//     <Router>
//       <nav className="app-nav">
//         <ul>
//           <li><Link to="/">View Menu</Link></li>
//           <li><Link to="/upload">Upload Page</Link></li>
//           <li><Link to="/manage">Manage Pages</Link></li>
//         </ul>
//       </nav>

//       <Routes>
//         <Route path="/" element={<MenuBook />} />
//         <Route path="/upload" element={<UploadMenuPage />} />
//         <Route path="/manage" element={<ManageMenuPages />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;





// // src/App.js

// // import React, { useEffect } from "react";
// // import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// // import MenuBook from "./components/MenuBook";
// // import UploadMenuPage from "./components/UploadMenuPage";
// // import ManageMenuPages from "./components/ManageMenuPages";

// // // Redirect component
// // const HomeRedirect = () => {
// //   useEffect(() => {
// //     // replace so user can’t click “Back” into your React app
// //     window.location.replace("https://lastoria-nine.vercel.app/");
// //   }, []);
// //   return null;  // nothing to render
// // };

// // function App() {
// //   return (
// //     <Router>
// //       <Routes>
// //         {/* redirect “/” immediately to your live Vercel URL */}
// //         <Route path="/" element={<HomeRedirect />} />

// //         {/* other client‐side routes will still work */}
// //         <Route path="/upload" element={<UploadMenuPage />} />
// //         <Route path="/manage" element={<ManageMenuPages />} />
// //       </Routes>
// //     </Router>
// //   );
// // }

// // export default App;


// src/App.js

import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";

import MenuBook from "./components/MenuBook";
import UploadMenuPage from "./components/UploadMenuPage";
import ManageMenuPages from "./components/ManageMenuPages";

const AppContent = () => {
  const { pathname } = useLocation();

  const showAdminNavigation = ["/upload", "/manage"].includes(pathname);

  return (
    <>
      {showAdminNavigation && (
        <nav className="app-nav">
          <ul>
            <li>
              <Link to="/">View Menu</Link>
            </li>

            <li>
              <Link to="/upload">Upload Page</Link>
            </li>

            <li>
              <Link to="/manage">Manage Pages</Link>
            </li>
          </ul>
        </nav>
      )}

      <Routes>
        <Route path="/" element={<MenuBook />} />
        <Route path="/upload" element={<UploadMenuPage />} />
        <Route path="/manage" element={<ManageMenuPages />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;